/** Locked M2 pathway catalog — prices match backend/config/pathways.py */

import { API_BASE } from './apiBase';

export const PATHWAY_CATALOG = {
  'family-i130': {
    id: 'family-i130',
    name: 'Family-Based I-130',
    price: '$299',
    priceNum: 299,
  },
  'aos-i485': {
    id: 'aos-i485',
    name: 'Adjustment of Status',
    price: '$199',
    priceNum: 199,
  },
  'perm-employer': {
    id: 'perm-employer',
    name: 'PERM / Employer-Sponsored',
    price: '$399',
    priceNum: 399,
  },
  'eb2-niw': {
    id: 'eb2-niw',
    name: 'EB-2 National Interest Waiver',
    price: '$499',
    priceNum: 499,
  },
  eb1a: {
    id: 'eb1a',
    name: 'EB-1A Extraordinary Ability',
    price: '$499',
    priceNum: 499,
  },
  asylum: {
    id: 'asylum',
    name: 'Asylum & Humanitarian',
    price: '$299',
    priceNum: 299,
  },
  'f1-change-status': {
    id: 'f1-change-status',
    name: 'F-1 / Change of Status',
    price: '$249',
    priceNum: 249,
  },
  'o1-nonimmigrant': {
    id: 'o1-nonimmigrant',
    name: 'O-1 Extraordinary Ability',
    price: '$349',
    priceNum: 349,
  },
  'dv-lottery': {
    id: 'dv-lottery',
    name: 'Diversity Visa (DV Lottery)',
    price: '$299',
    priceNum: 299,
  },
};

export const AOS_ELIGIBLE = new Set([
  'family-i130',
  'perm-employer',
  'eb2-niw',
  'eb1a',
  'asylum',
  'dv-lottery',
]);

export const ATTY_REVIEW_PRICES = {
  'family-i130': 99,
  'dv-lottery': 99,
  'f1-change-status': 99,
  'aos-i485': 149,
  'o1-nonimmigrant': 149,
  asylum: 149,
  'perm-employer': 149,
  'eb2-niw': 199,
  eb1a: 199,
};

export function getPathway(pathwayId) {
  return PATHWAY_CATALOG[pathwayId] || null;
}

/** Pathway to buy: current workflow URL first, then eligibility/pending intent. */
export function resolvePurchaseTarget(pathname) {
  const match = String(pathname || '').match(/^\/workflow\/([^/?#]+)/);
  if (match && getPathway(match[1])) return match[1];
  const pending = peekPendingPurchase();
  if (pending && getPathway(pending)) return pending;
  return null;
}

export function requestPathwayPurchase() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('immigrate:purchase'));
}

/** Persist intent so auth / dashboard can resume checkout. */
export function setPendingPurchase(pathwayId) {
  try {
    localStorage.setItem('eligibility_pending_pathway', pathwayId || '');
    localStorage.setItem('pending_purchase', pathwayId || '');
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('immigrate:pending-purchase', { detail: pathwayId || '' }));
    }
  } catch {
    /* ignore */
  }
}

export function peekPendingPurchase() {
  try {
    return (
      localStorage.getItem('pending_purchase') ||
      localStorage.getItem('eligibility_pending_pathway') ||
      null
    );
  } catch {
    return null;
  }
}

export function consumePendingPurchase() {
  try {
    const id = peekPendingPurchase();
    localStorage.removeItem('pending_purchase');
    localStorage.removeItem('eligibility_pending_pathway');
    return id || null;
  } catch {
    return null;
  }
}

export async function createPathwayCheckoutSession(
  pathwayId,
  { attorney_review = false, aos_addon = false } = {}
) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Sign in required to purchase');
  }
  const response = await fetch(
    `${API_BASE}/api/billing/checkout`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        pathway_id: pathwayId,
        attorney_review,
        aos_addon,
      }),
    }
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.url) {
    const detail = data.detail;
    const msg =
      (typeof detail === 'object' && detail?.message) ||
      detail ||
      data.message ||
      'Failed to create checkout session. Please try again.';
    throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
  }
  return data.url;
}
